"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var utils_1 = require("./utils");

var Tick;

(function (Tick) {
  Tick[Tick["INIT"] = 0] = "INIT";
  Tick[Tick["WRITE"] = 1] = "WRITE";
  Tick[Tick["DELETE"] = 2] = "DELETE";
  Tick[Tick["START_DELETE"] = 3] = "START_DELETE";
})(Tick || (Tick = {}));

var DEFAULTS = {
  WRITE_SPEED_MS: 100,
  DELETE_SPEED_MS: 60,
  WAIT_BEFORE_DELETE_MS: 9000
};

var moveToNextString = function moveToNextString(prevState, props) {
  var nextStringIdx = prevState.currentStringIdx + 1;
  return {
    isDeleting: false,
    currentCharPos: 0,
    currentStringIdx: nextStringIdx < props.strings.length ? nextStringIdx : 0
  };
};

var moveCharPos = function moveCharPos(change) {
  return function (prevState) {
    return {
      currentCharPos: prevState.currentCharPos + change
    };
  };
};

var startDeleting = function startDeleting() {
  return {
    isDeleting: true
  };
};

var Typewriting = function (_super) {
  __extends(Typewriting, _super);

  function Typewriting() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.tickTimeout = null;
    _this.state = {
      currentStringIdx: 0,
      currentCharPos: 0,
      isDeleting: false
    };
    return _this;
  }

  Typewriting.prototype.componentDidMount = function () {
    this.queueTick(Tick.INIT);
  };

  Typewriting.prototype.componentWillUnmount = function () {
    if (this.tickTimeout != null) {
      clearTimeout(this.tickTimeout);
    }
  };

  Typewriting.prototype.queueTick = function (tickType) {
    var _this = this;

    var _a = this.props,
        writeSpeedMs = _a.writeSpeedMs,
        deleteSpeedMs = _a.deleteSpeedMs,
        waitBeforeDeleteMs = _a.waitBeforeDeleteMs;
    var timeout = tickType === Tick.INIT ? 0 : tickType === Tick.WRITE ? utils_1.randomizeTimeout(writeSpeedMs != null ? writeSpeedMs : DEFAULTS.WRITE_SPEED_MS) : tickType === Tick.DELETE ? utils_1.randomizeTimeout(deleteSpeedMs != null ? deleteSpeedMs : DEFAULTS.DELETE_SPEED_MS) : tickType === Tick.START_DELETE ? waitBeforeDeleteMs != null ? waitBeforeDeleteMs : DEFAULTS.WAIT_BEFORE_DELETE_MS : 0; // ¯\_(ツ)_/¯

    this.tickTimeout = window.setTimeout(function () {
      return _this.tick();
    }, timeout);
  };

  Typewriting.prototype.tick = function () {
    var _this = this;

    var _a = this.state,
        currentStringIdx = _a.currentStringIdx,
        currentCharPos = _a.currentCharPos,
        isDeleting = _a.isDeleting;
    var currentText = this.props.strings[currentStringIdx];

    if (!isDeleting) {
      if (currentCharPos >= currentText.length) {
        this.setState(startDeleting, function () {
          return _this.queueTick(Tick.START_DELETE);
        });
      } else {
        this.setState(moveCharPos(1), function () {
          return _this.queueTick(Tick.WRITE);
        });
      }
    } else {
      if (currentCharPos <= 0) {
        this.setState(moveToNextString, function () {
          return _this.queueTick(Tick.WRITE);
        });
      } else {
        this.setState(moveCharPos(-1), function () {
          return _this.queueTick(Tick.DELETE);
        });
      }
    }
  };

  Typewriting.prototype.render = function () {
    var strings = this.props.strings;
    var _a = this.state,
        currentStringIdx = _a.currentStringIdx,
        currentCharPos = _a.currentCharPos;
    var fullCurrentText = strings[currentStringIdx];
    var currentText = fullCurrentText.slice(0, currentCharPos);
    return this.props.children({
      currentText: currentText,
      fullCurrentText: fullCurrentText
    });
  };

  return Typewriting;
}(React.PureComponent);

exports.Typewriting = Typewriting; // for backwards compatibility

exports.default = Typewriting;